export const useStreamerStatistic = (
  slug: MaybeRefOrGetter<string | undefined>,
) => {
  return useQuery({
    refetchOnWindowFocus: false,
    enabled: () => !!toValue(slug),
    queryKey: ['streamer-statistic', slug],
    queryFn: ({ signal }) =>
      $api<StreamStatistic>('/stream/statistic', {
        type: UserType.STREAMER,
        method: 'POST',
        signal,
        body: { slug: toValue(slug) },
      }),
  })
}
